// WebGL2 capability probe. Returns a structured verdict so the Decision Graph
// can hard-fall-back to the accessible 2D summary when 3D is unsupported.
// Never throws — a failed probe is a "not supported" verdict, not an error.
export function probeWebGL2() {
  const verdict = {
    supported: false,
    reason: "unknown",
    renderer: null,
    vendor: null,
    maxTextureSize: null,
  };
  if (typeof window === "undefined" || typeof document === "undefined") {
    verdict.reason = "no_document";
    return verdict;
  }
  let canvas;
  try {
    canvas = document.createElement("canvas");
    const gl = canvas.getContext("webgl2");
    if (!gl) {
      verdict.reason = "webgl2_context_unavailable";
      return verdict;
    }
    const dbg = gl.getExtension("WEBGL_debug_renderer_info");
    verdict.renderer = dbg ? gl.getParameter(dbg.UNMASKED_RENDERER_WEBGL) : "unavailable";
    verdict.vendor = dbg ? gl.getParameter(dbg.UNMASKED_VENDOR_WEBGL) : "unavailable";
    verdict.maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
    verdict.supported = true;
    verdict.reason = "ok";
    // Detect a software rasterizer — 3D is technically available but too slow
    // to run the cinematic; caller may still choose the 2D fallback.
    const r = String(verdict.renderer || "").toLowerCase();
    verdict.software = r.includes("swiftshader") || r.includes("llvmpipe") || r.includes("software");
    return verdict;
  } catch (e) {
    verdict.reason = "probe_exception";
    return verdict;
  } finally {
    if (canvas) {
      const gl = canvas.getContext("webgl2");
      const lose = gl && gl.getExtension("WEBGL_lose_context");
      if (lose) lose.loseContext();
    }
  }
}
